module.exports = __webpack_public_path__ + "static/media/3.36a0eb2e.jpg";